import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TEvaluationRuleGroup {
  businessRuleGroup: number;
  businessRuleGroupDescription: string;
  businessRuleGroupEvaluationId: number;
  businessRuleGroupEvaluationResult: string;
  businessRuleGroupEvaluationDifficultyFactor: number;
  businessRuleGroupName: string;
  difficultyThreshold: number;
  errorLog: string;
}

export interface IEvaluationRuleGroup extends TEvaluationRuleGroup {}

const EvaluationRuleGroup = Model(
  (model: TEvaluationRuleGroup): IEvaluationRuleGroup => {
    const _evaluationRuleGroup: TEvaluationRuleGroup = Object.assign({}, model);

    let create = (
      evaluationRuleGroup: IEvaluationRuleGroup
    ): IEvaluationRuleGroup => {
      let obj = ValidatableObject(evaluationRuleGroup);
      return obj;
    };

    let evaluationRuleGroup = {
      get businessRuleGroup() {
        return _evaluationRuleGroup.businessRuleGroup;
      },
      set businessRuleGroup(value) {
        _evaluationRuleGroup.businessRuleGroup = value;
      },
      get businessRuleGroupDescription() {
        return _evaluationRuleGroup.businessRuleGroupDescription;
      },
      set businessRuleGroupDescription(value) {
        _evaluationRuleGroup.businessRuleGroupDescription = value;
      },
      get businessRuleGroupEvaluationId() {
        return _evaluationRuleGroup.businessRuleGroupEvaluationId;
      },
      set businessRuleGroupEvaluationId(value) {
        _evaluationRuleGroup.businessRuleGroupEvaluationId = value;
      },
      get businessRuleGroupEvaluationResult() {
        return _evaluationRuleGroup.businessRuleGroupEvaluationResult;
      },
      set businessRuleGroupEvaluationResult(value) {
        _evaluationRuleGroup.businessRuleGroupEvaluationResult = value;
      },
      get businessRuleGroupEvaluationDifficultyFactor() {
        return _evaluationRuleGroup.businessRuleGroupEvaluationDifficultyFactor;
      },
      set businessRuleGroupEvaluationDifficultyFactor(value) {
        _evaluationRuleGroup.businessRuleGroupEvaluationDifficultyFactor = value;
      },
      get businessRuleGroupName() {
        return _evaluationRuleGroup.businessRuleGroupName;
      },
      set businessRuleGroupName(value) {
        _evaluationRuleGroup.businessRuleGroupName = value;
      },
      get difficultyThreshold() {
        return _evaluationRuleGroup.difficultyThreshold;
      },
      set difficultyThreshold(value) {
        _evaluationRuleGroup.difficultyThreshold = value;
      },
      get errorLog() {
        return _evaluationRuleGroup.errorLog;
      },
      set errorLog(value) {
        _evaluationRuleGroup.errorLog = value;
      }
    };
    return create(evaluationRuleGroup);
  }
);

export default EvaluationRuleGroup;
